import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";

function Spinner() {
  return (
    <div className="h-screen flex items-center justify-center">
      <div className="h-10 w-10 rounded-full border-2 border-primary border-t-transparent animate-spin" />
    </div>
  );
}

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <Spinner />;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

export function SuperRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <Spinner />;
  if (user === false) return <Navigate to="/login" replace />;
  if (user.role !== "super_admin") return <Navigate to="/" replace />;
  return children;
}
